import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./About.css";

gsap.registerPlugin(ScrollTrigger);

function AboutRoadmapDivider() {
  const wrapRef = useRef(null);
  const barRef = useRef(null);
  const bubblesRef = useRef(null);

  useEffect(() => {
    const wrap = wrapRef.current;
    const bar = barRef.current;
    const bubbles = bubblesRef.current;
    if (!wrap || !bar || !bubbles) return;

    const bubbleEls = bubbles.querySelectorAll(".about-roadmap-divider__bubble");

    /* Reset for animation */
    gsap.set(bar, { scaleX: 0, transformOrigin: "center center" });
    gsap.set(bubbleEls, { scale: 0, opacity: 0 });

    /* Bar: expand from center when in view */
    gsap.to(bar, {
      scaleX: 1,
      duration: 0.8,
      ease: "back.out(1.4)",
      scrollTrigger: {
        trigger: wrap,
        start: "top 85%",
        toggleActions: "play none none none",
      },
    });

    /* Bubbles: pop in with stagger after bar */
    gsap.to(bubbleEls, {
      scale: 1,
      opacity: 1,
      duration: 0.4,
      stagger: 0.1,
      ease: "back.out(2)",
      delay: 0.2,
      scrollTrigger: {
        trigger: wrap,
        start: "top 85%",
        toggleActions: "play none none none",
      },
    });

    /* Subtle looping bounce on bubbles (Milk Dragon cartoon feel) - starts after entrance */
    const bounceTl = gsap.timeline({ delay: 1.2, repeat: -1, repeatDelay: 1.5 });
    bounceTl.to(bubbleEls, {
      y: -4,
      duration: 0.35,
      stagger: 0.08,
      ease: "sine.inOut",
    }).to(bubbleEls, {
      y: 0,
      duration: 0.35,
      stagger: 0.08,
      ease: "sine.inOut",
    });

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
      bounceTl.kill();
    };
  }, []);

  return (
    <div
      ref={wrapRef}
      className="about-roadmap-divider"
      aria-hidden="true"
    >
      <div ref={bubblesRef} className="about-roadmap-divider__bubbles">
        <span className="about-roadmap-divider__bubble" />
        <span className="about-roadmap-divider__bubble" />
        <span className="about-roadmap-divider__bubble" />
      </div>
      <div ref={barRef} className="about-roadmap-divider__bar" />
    </div>
  );
}

export default AboutRoadmapDivider;
